import moment from "moment";
import getIsoPeriodStart from "utils/getIsoPeriodStart";

// True only when `date` is itself the first day (Monday) of an ISO reporting period. Reuses
// getIsoPeriodStart so the rule stays identical to the backend IsoPeriodService: periods are four
// ISO weeks and capped at 13 per year, so weeks 50-53 fold into period 13 and are never starts.
export default function isIsoPeriodStart(date) {
    if (date == null) {
        return false;
    }

    const value = moment(date);
    if (!value.isValid()) {
        return false;
    }

    return getIsoPeriodStart(value).isSame(value, "day");
}
